// src/components/BTMConfigurator.js
import React, { useState, useEffect, useContext } from 'react';
import { CartContext } from '../context/CartContext';
import { AuthContext } from '../context/AuthContext';
// import { useNavigate } from 'react-router-dom';
import '../css/Configurator.css'; // classi condivise (colori, lunghezze, messaggio) finché il BTM non viene ridisegnato
import '../css/BTMConfigurator.css';
import successSound from '../assets/success.mp3';
import { FaFilePdf } from 'react-icons/fa';
import { urlAsset } from './utils';
import { useLanguage } from '../context/LanguageContext';

// Selettore prezzo per colore/lunghezza
const getPriceForColorAndLength = (priceObject, selectedColor, selectedLength) => {
  if (priceObject == null) return null;

  // Caso A: prezzo unico (numero) -> uguale per tutti i colori / lunghezze
  if (typeof priceObject === 'number') {
    return priceObject;
  }

  // Caso B: oggetto -> puo essere per colore, o direttamente per lunghezza
  let priceForColor;

  if (selectedColor && priceObject[selectedColor] != null) {
    // Struttura classica: { "5": ..., "6": ... }
    priceForColor = priceObject[selectedColor];
  } else {
    // Nessun colore (o non trovato) -> usiamo l'oggetto direttamente
    // utile per eventuali casi tipo { "30": 100, "60": 150 }
    priceForColor = priceObject;
  }

  // Se il valore e un oggetto e abbiamo una lunghezza, cerchiamo per lunghezza
  if (priceForColor && typeof priceForColor === 'object' && selectedLength) {
    const byLength = priceForColor[selectedLength];
    return byLength != null ? byLength : null;
  }

  // Altrimenti, se e un numero, e il prezzo
  return typeof priceForColor === 'number' ? priceForColor : null;
};

const ProductDetails = ({
  product,
  selectedColor,
  setSelectedColor,
  selectedLength,
  setSelectedLength,
  handleAddToCart,
  quantity,
  setQuantity,
  handleZoomClick,
  voltage,
  showTechnicalImage = false,
  showPrices = true,
}) => {
  const { user } = useContext(AuthContext);
  const { t } = useLanguage();
  const hasColorOptions =
    Array.isArray(product.colorOptions) && product.colorOptions.length > 0;
  const colorLabelByCode = {
    '5': t('btm.white'),
    '6': t('btm.black'),
  };
  const getColorLabel = (code) => colorLabelByCode[code] || code || '';
  const getColorCode = (code) => {
    if (code === '5') return '#ffffff';
    if (code === '6') return '#000000';
    return '#f3f4f6';
  };

  // Preseleziona lunghezza minima, se presente
  useEffect(() => {
    if (
      product.lengthOptions &&
      product.lengthOptions.length > 0 &&
      !selectedLength &&
      typeof setSelectedLength === 'function'
    ) {
      const minLength = product.lengthOptions.reduce((prev, curr) =>
        prev.length < curr.length ? prev : curr
      );
      setSelectedLength(minLength);
    }
  }, [product, setSelectedLength, selectedLength]);

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setQuantity(product.id, !isNaN(value) && value > 0 ? value : 1);
  };

    // Codice prodotto: ID + (codice lunghezza se presente) + (codice colore SOLO se esiste il colore)
  const lengthCode = selectedLength?.code || '';
  const colorCode = hasColorOptions ? selectedColor || '' : '';
  const productCode = `${product.id}${lengthCode}${colorCode}`;

  // Prezzi
    const priceForColorAndLength = getPriceForColorAndLength(
    product.price,
    hasColorOptions ? selectedColor : null,
    selectedLength?.length
  );

  const discount = user?.discount || 0;
  const netPrice =
    priceForColorAndLength && !isNaN(priceForColorAndLength)
      ? (priceForColorAndLength * (1 - discount / 100)).toFixed(2)
      : null;

  const voltageLabel = product.voltage || voltage || '';
  const normalizeText = (value) => String(value || '').replace(/\u00C2\u00B0/g, '°').trim();
  const getLocalizedText = (scope, fallback) => {
    const key = `btm.${scope}.${product.id}`;
    const localized = t(key);
    if (localized && localized !== key) return localized;
    return normalizeText(fallback);
  };
  const displayName = getLocalizedText('itemNames', product.name);
  const displayDescription = getLocalizedText('itemDescriptions', product.description);

  return (
    <div className="product-details">
      {showTechnicalImage ? (
        <div className="btm-profile-visual-grid">
          <button
            type="button"
            className="btm-profile-visual-card"
            onClick={() => handleZoomClick(product.image)}
          >
            <span>{t('configurator.profileImage')}</span>
            <img
              src={urlAsset(product.image)}
              alt={displayName}
              className="product-image"
              style={{ cursor: 'zoom-in' }}
            />
          </button>

          {product.imageTech && (
            <button
              type="button"
              className="btm-profile-visual-card"
              onClick={() => handleZoomClick(product.imageTech)}
            >
              <span>{t('configurator.technicalDrawing')}</span>
              <img
                src={urlAsset(product.imageTech)}
                alt={`${displayName} tecnico`}
                className="product-image"
                style={{ cursor: 'zoom-in' }}
              />
            </button>
          )}
        </div>
      ) : (
        <img
          src={urlAsset(product.image)}
          alt={displayName}
          className="product-image"
          onClick={() => handleZoomClick(product.image)}
          style={{ cursor: 'zoom-in' }}
        />
      )}
      <p>{displayDescription}</p>

      {voltageLabel && (
        <p>
          <strong>{t('btm.voltage')}:</strong> {voltageLabel}
        </p>
      )}

      {product.datasheet && (
        <div className="datasheet-link" style={{ marginBottom: '16px' }}>
          <a href={urlAsset(`/datasheet/${product.datasheet}`)} target="_blank" rel="noopener noreferrer">
            <FaFilePdf style={{ color: 'red', fontSize: '24px', marginRight: '8px' }} />
            <span>{t('btm.datasheet')}</span>
          </a>
        </div>
      )}

      {/* Colore */}
      {hasColorOptions && (
        <div className="btm-selector-block btm-selector-profile-like">
          <p className="btm-selector-title">{t('configurator.profileColor')}</p>
          <div className="color-selection">
            {product.colorOptions.map((colorCode) => (
              <label
                key={colorCode}
                className={`color-box ${colorCode === '6' ? 'dark-chip' : ''} ${
                  selectedColor === colorCode ? 'selected' : ''
                }`}
                style={{ backgroundColor: getColorCode(colorCode) }}
              >
                <input
                  type="radio"
                  name={`btm-color-${product.id}`}
                  value={colorCode}
                  checked={selectedColor === colorCode}
                  onChange={() => setSelectedColor(colorCode)}
                />
                <span className={colorCode === '5' ? 'black-text' : ''}>{getColorLabel(colorCode)}</span>
              </label>
            ))}
          </div>
        </div>
      )}

      {/* Lunghezze */}
      {product.lengthOptions && (
        <div className="btm-selector-block btm-selector-profile-like">
          <p className="btm-selector-title">{t('configurator.profileLength')}</p>
          <div className="loose-profile-length-grid">
            {product.lengthOptions.map((lengthOption) => (
              <label
                key={lengthOption.code}
                className={`loose-length-card ${
                  selectedLength && selectedLength.code === lengthOption.code ? 'selected' : ''
                }`}
              >
                <input
                  type="radio"
                  name={`btm-length-${product.id}`}
                  value={lengthOption.code}
                  checked={selectedLength && selectedLength.code === lengthOption.code}
                  onChange={() =>
                    typeof setSelectedLength === 'function' && setSelectedLength(lengthOption)
                  }
                />
                <strong>{lengthOption.length} cm</strong>
                <span>{lengthOption.length / 100} m</span>
              </label>
            ))}
          </div>
        </div>
      )}

      {/* Prezzi */}
      {showPrices ? (
        <>
          <p>
            <strong>{t('btm.listPrice')}:</strong>{' '}
            {priceForColorAndLength !== null && !isNaN(priceForColorAndLength)
              ? `EUR ${priceForColorAndLength.toFixed(2)}`
              : t('btm.unavailablePrice')}
          </p>
          <p style={{ color: 'green' }}>
            <strong>{t('btm.netPrice')}:</strong> {netPrice !== null ? `EUR ${netPrice}` : t('btm.unavailablePrice')}
          </p>
        </>
      ) : (
        <p>
          <strong>{t('btm.prices')}:</strong> {t('btm.hidden')}
        </p>
      )}
      <p>{t('btm.code')}: {productCode}</p>

      {/* Quantita */}
      <input
        type="number"
        min="1"
        value={quantity[product.id] || 1}
        onChange={handleQuantityChange}
        className="btm-quantity-input"
      />

      {/* Aggiungi al carrello */}
      <button
  type="button"
  onClick={() => {
    const itemToAdd = {
      name: displayName,
      code: productCode,
      color: hasColorOptions ? selectedColor : null,
      length: selectedLength ? selectedLength.length : null,
      unitPrice: priceForColorAndLength,
      description: `${displayName}${
        hasColorOptions ? `, ${getColorLabel(selectedColor)}` : ''
      }${selectedLength ? `, ${selectedLength.length}cm` : ''}${
        voltageLabel ? `, ${voltageLabel}` : ''
      }`,
      datasheet: product.datasheet || null,
      quantity: quantity[product.id] || 1,
    };

    console.log('[BTM] addToCart item:', itemToAdd); // per verifica
    handleAddToCart(itemToAdd);
  }}
>
  {t('btm.addToCart')}
</button>
    </div>
  );
};

const BTMConfigurator = ({ onSearch, searchResults, showPrices = true }) => {
  const { addToCart } = useContext(CartContext);
  const { user } = useContext(AuthContext);
  const { t } = useLanguage();

const [voltage, setVoltage] = useState(null); // '24VDC' | '230VAC'

const configUrls = {
  '24VDC': '/api/products/config/btmConfig',
  '230VAC': '/api/products/config/btmConfig'  // stesso JSON
};


  // Stato configuratore
  const [configData, setConfigData] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedModelLength, setSelectedModelLength] = useState(null);
  const [selectedProductLengths, setSelectedProductLengths] = useState({});
  const [selectedColor, setSelectedColor] = useState('5');
  const [quantities, setQuantities] = useState({});
  const [expandedItems, setExpandedItems] = useState({});
  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomedImage, setZoomedImage] = useState(null);

  // Carica JSON in base all alimentazione
  useEffect(() => {
    if (!voltage) return;
    setConfigData(null);
    setSelectedModel(null);
    setSelectedModelLength(null);
    setSelectedProductLengths({});
    setExpandedItems({});
    setQuantities({});
    setSelectedColor('5');

    const url = configUrls[voltage];
    fetch(url)
  .then((r) => r.json())
  .then((data) => {
    // Il tuo JSON e { version, data: { binari, accessories, products } }
    // Quindi salviamo direttamente la parte "data"
    const payload = data.data || data;
    setConfigData(payload);
  })
  .catch((error) =>
    console.error('Error loading configuration file:', error)
  );


  }, [voltage]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleModelSelect = (model) => {
    setSelectedModel(model);
    setSelectedColor('5');
    setSelectedModelLength(model.lengthOptions ? model.lengthOptions[0] : null);
    setSelectedProductLengths({});
  };

  const handleAddToCart = (item) => {
    addToCart({ ...item });
    showMessage(t('btm.messageAddedToCart', { name: item.name }));
    playSound();
  };

  const showMessage = (message) => {
    const messageDiv = document.getElementById('add-message');
    if (!messageDiv) return;
    messageDiv.innerText = message;
    messageDiv.style.display = 'block';
    setTimeout(() => {
      messageDiv.style.display = 'none';
    }, 2000);
  };

  const playSound = () => {
    const audio = new Audio(successSound);
    audio.play();
  };

  const handleZoomClick = (image) => {
    setZoomedImage(image);
    setIsZoomed(true);
  };

  const closeZoom = () => {
    setIsZoomed(false);
    setZoomedImage(null);
  };

  const handleBackModels = () => {
    setSelectedModel(null);
  };

  const toggleExpand = (id) => {
    setExpandedItems((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  // Filtra elementi per tensione, con fallback:
// - se l'elemento NON ha "voltage", lo consideriamo 24VDC (configurazione legacy)
// - se ha voltage: '24VDC' o '230VAC' lo confrontiamo normalmente
// - opzionale: valori 'ALL' / 'BOTH' per accessori comuni a entrambe
const filterByVoltage = (items) =>
  (items || []).filter((item) => {
    if (!item.voltage) {
      // Tutto cio che non ha ancora il flag e trattato come 24VDC
      return voltage === '24VDC';
    }

    if (item.voltage === 'ALL' || item.voltage === 'BOTH') {
      return true;
    }

    return item.voltage === voltage;
  });


  const getFilteredAccessories = (modelName) => {
  if (!modelName) return [];

  const modelNorm = modelName.toUpperCase().trim();

  return (
    filterByVoltage(configData?.accessories)?.filter((a) => {
      const compatList = a.compatibleWith || [];
      return compatList.some((c) => {
        const cNorm = String(c).toUpperCase().trim();

        // 1) match esatto (ST1, ST2, ...)
        if (cNorm === modelNorm) return true;

        // 2) match per famiglia: es. "ONETRACK" contenuto in "ONETRACK TRIFASE +DALI"
        if (modelNorm.includes(cNorm)) return true;

        // 3) caso inverso (per sicurezza)
        if (cNorm.includes(modelNorm)) return true;

        return false;
      });
    }) || []
  );
};


const getFilteredProducts = (modelName) => {
  if (!modelName) return [];

  const modelNorm = modelName.toUpperCase().trim();

  return (
    filterByVoltage(configData?.products)?.filter((p) => {
      const compatList = p.compatibleWith || [];
      return compatList.some((c) => {
        const cNorm = String(c).toUpperCase().trim();

        if (cNorm === modelNorm) return true;
        if (modelNorm.includes(cNorm)) return true;
        if (cNorm.includes(modelNorm)) return true;

        return false;
      });
    }) || []
  );
};;


  const setQuantity = (productId, value) => {
    setQuantities((prev) => ({ ...prev, [productId]: value }));
  };

  // Schermata scelta alimentazione
  if (!voltage) {
    const handleKeyPick = (e, val) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setVoltage(val);
      }
    };

    return (
      <div className="btm-configurator-container">
        <div className="btm-voltage-picker">
          <h2>{t('btm.voltageSelect')}</h2>
          <div className="btm-voltage-cards">
            <div
              className="btm-voltage-card dc"
              role="button"
              tabIndex={0}
              onClick={() => setVoltage('24VDC')}
              onKeyDown={(e) => handleKeyPick(e, '24VDC')}
              aria-label={t('btm.select24')}
            >
              <span className="btm-voltage-label">24VDC</span>
            </div>

            <div
              className="btm-voltage-card ac"
              role="button"
              tabIndex={0}
              onClick={() => setVoltage('230VAC')}
              onKeyDown={(e) => handleKeyPick(e, '230VAC')}
              aria-label={t('btm.select230')}
            >
              <span className="btm-voltage-label">230VAC</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Caricamento JSON
  if (!configData) {
    return (
      <div className="btm-configurator-container">
        <div className="btm-loading">{t('btm.loading', { voltage })}</div>
      </div>
    );
  }

  // Nel configuratore BTM mostriamo sempre gli elementi compatibili col binario selezionato.
  // Riutilizzare i risultati della ricerca globale qui porta a mix errati tra catalogo,
  // alimentatori e prodotti BTM, soprattutto cambiando tensione o pagina.
  const getLocalizedItemName = (item) => {
    if (!item) return '';
    const key = `btm.itemNames.${item.id}`;
    const localized = t(key);
    if (localized && localized !== key) return localized;
    return String(item.name || '').replace(/\u00C2\u00B0/g, '°').trim();
  };
  const displayedAccessories = getFilteredAccessories(selectedModel?.name) || [];

  const displayedProducts = getFilteredProducts(selectedModel?.name) || [];
  const selectedTrackColorLabel = selectedColor === '5' ? t('btm.white') : t('btm.black');

  return (
    <div className="btm-configurator-container">
      <div id="add-message" className="success-message" style={{ display: 'none' }}></div>

      {/* TOPBAR flottante: alimentazione + cambia + (se serve) indietro ai modelli */}
      <div className="btm-topbar">
        <span className="btm-topbar-pill">{voltage}</span>
        {selectedModel && (
          <button
            className="btm-topbar-back"
            onClick={handleBackModels}
            aria-label={t('btm.backModelsAria')}
            title={t('btm.backModelsTitle')}
          >
            {'<- '} {t('btm.backModels')}
          </button>
        )}
        <button
          className="btm-topbar-back"
          onClick={() => setVoltage(null)}
          aria-label={t('btm.changeSupplyAria')}
          title={t('btm.changeSupplyTitle')}
        >
          {t('btm.changeSupply')}
        </button>
      </div>

      {user && (
        <>
          {/* Scelta modello */}
          {!selectedModel ? (
            <div className="btm-main-container">
              <h2>{t('btm.chooseTrackModel')}</h2>
              <div className="btm-model-selection">
                {filterByVoltage(configData.binari).map((model) => (
                  <div
                    key={model.id}
                    className="btm-model-item"
                    onClick={() => handleModelSelect(model)}
                  >
                    <img
                      src={urlAsset(model.image)}
                      alt={model.name}
                      style={{ cursor: 'pointer' }}
                    />
                    <span>{model.name}</span>
                    <p>{model.type}</p>
                  </div>
                ))}
              </div>

              <div className="btm-pdf-download">
  <a
    href={urlAsset(
      voltage === '230VAC'
        ? '/datasheet/Onetrack.pdf' // nuovo PDF per 230VAC
        : '/datasheet/Evo.pdf'        // PDF attuale per 24VDC
    )}
    target="_blank"
    rel="noopener noreferrer"
  >
    {voltage === '230VAC' ? t('btm.downloadOnetrackPdf') : t('btm.downloadEvoPdf')}
  </a>
</div>

            </div>
          ) : (
            <>
              {/* Colonna sinistra: modello scelto */}
              <div className="btm-configurator-left">
                <h2>{selectedModel.name}</h2>
                <div className="btm-track-selection-summary">
                  <div className="btm-track-summary-item">
                    <span>{t('configurator.profileColor')}</span>
                    <strong>{selectedTrackColorLabel}</strong>
                  </div>
                  <div className="btm-track-summary-item">
                    <span>{t('configurator.profileLength')}</span>
                    <strong>{selectedModelLength ? `${selectedModelLength.length} cm` : '-'}</strong>
                  </div>
                  <div className="btm-track-summary-item">
                    <span>{t('btm.accessories')}</span>
                    <strong>{displayedAccessories.length}</strong>
                  </div>
                  <div className="btm-track-summary-item">
                    <span>{t('btm.installableProducts')}</span>
                    <strong>{displayedProducts.length}</strong>
                  </div>
                </div>
                <div className="btm-selected-profile btm-item-container">
                    <ProductDetails
                      product={selectedModel}
                      selectedColor={selectedColor}
                      setSelectedColor={setSelectedColor}
                      selectedLength={selectedModelLength}
                      setSelectedLength={setSelectedModelLength}
                      handleAddToCart={handleAddToCart}
                      quantity={quantities}
                      setQuantity={setQuantity}
                      handleZoomClick={handleZoomClick}
                      voltage={voltage}
                      showTechnicalImage={true}
                      showPrices={showPrices}
                    />
                </div>
              </div>

              {/* Colonna centrale: accessori */}
              <div className="btm-configurator-middle">
                <div className="collapsible-section">
                  <h2>{t('btm.accessories')}</h2>
                  {displayedAccessories.map((accessory) => (
                    <div key={accessory.id} className="btm-collapsible-item">
                      <div
                        className="btm-collapsible-header"
                        onClick={() => toggleExpand(accessory.id)}
                      >
                        <h3>{getLocalizedItemName(accessory)}</h3>
                        <span>{expandedItems[accessory.id] ? '-' : '+'}</span>
                      </div>
                      {expandedItems[accessory.id] && (
                        <ProductDetails
                          product={accessory}
                          selectedColor={selectedColor}
                          setSelectedColor={setSelectedColor}
                          handleAddToCart={handleAddToCart}
                          quantity={quantities}
                          setQuantity={setQuantity}
                          handleZoomClick={handleZoomClick}
                          voltage={voltage}
                          showPrices={showPrices}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Colonna destra: prodotti installabili */}
              <div className="btm-configurator-right">
                <div className="collapsible-section">
                  <h2>{t('btm.installableProducts')}</h2>
                  {displayedProducts.map((product) => (
                    <div key={product.id} className="btm-collapsible-item">
                      <div
                        className="btm-collapsible-header"
                        onClick={() => toggleExpand(product.id)}
                      >
                        <h3>{getLocalizedItemName(product)}</h3>
                        <span>{expandedItems[product.id] ? '-' : '+'}</span>
                      </div>
                      {expandedItems[product.id] && (
                        <ProductDetails
                          product={product}
                          selectedColor={selectedColor}
                          setSelectedColor={setSelectedColor}
                          selectedLength={product.lengthOptions ? selectedProductLengths[product.id] : null}
                          setSelectedLength={
                            product.lengthOptions
                              ? (value) =>
                                  setSelectedProductLengths((prev) => ({
                                    ...prev,
                                    [product.id]: value,
                                  }))
                              : undefined
                          }
                          handleAddToCart={handleAddToCart}
                          quantity={quantities}
                          setQuantity={setQuantity}
                          handleZoomClick={handleZoomClick}
                          voltage={voltage}
                          showPrices={showPrices}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}

          {/* Zoom modal */}
          {isZoomed && (
            <div className="zoom-modal" onClick={closeZoom}>
              <span className="close-zoom" onClick={closeZoom}>
                &times;
              </span>
              <img src={urlAsset(zoomedImage)} alt="Zoomed" className="zoomed-image" />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BTMConfigurator;


